import Manager from './Manager'
export default Manager
